import { ColoursObj, Icon, Typography } from "@eventr/common-storybook";
import { CardText } from "./cardText";
import { RowInfo } from "./rowInfo";
import { cardTranslation } from "i18n/translateHelpers";

interface IRowInfoAirlineProps {
  airline: string;
  type?: "card" | "page";
}
export const RowInfoAirline = ({ airline, type }: IRowInfoAirlineProps) => {
  if (!airline) return null;
  if (type === "page") {
    return (
      <RowInfo
        start={<Icon name="Airline" iconColour={ColoursObj.coreBrights.primary} />}
        under={<CardText>{airline}</CardText>}
        middle={<Typography variant="bodyBold">{cardTranslation("Airline")}</Typography>}
      />
    );
  }
  return (
    <RowInfo
      start={<Icon name="Airline" bubble bubbleColour={ColoursObj.coreBrights.primary} />}
      middle={<CardText useMarkdown>{airline}</CardText>}
    />
  );
};
